export default __webpack_public_path__ + "static/media/dislike.0399973f.svg";